import { render, staticRenderFns } from "./AddNewServiceProviderUserForm.vue?vue&type=template&id=a5443616&scoped=true"
import script from "./AddNewServiceProviderUserForm.vue?vue&type=script&lang=js"
export * from "./AddNewServiceProviderUserForm.vue?vue&type=script&lang=js"
import style0 from "./AddNewServiceProviderUserForm.vue?vue&type=style&index=0&id=a5443616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5443616",
  null
  
)

export default component.exports